import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileModel} from '@core/modules/rest/file/file.model';
import {FileRestService} from '@core/modules/rest/file/file-rest.service';
import {FileTypeEnum} from '@core/modules/rest/file/file-type.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-image-card',
    templateUrl: './image-card.component.html',
    styleUrls: ['./image-card.component.scss']
})
export class ImageCardComponent implements OnInit {
    @Input() showCheckbox: boolean;
    @Input() image: FileModel;
    @Output() imageMarkedEvent = new EventEmitter<string>();
    @Output() imageClickedEvent = new EventEmitter<{ path: string, type: FileTypeEnum }>();
    @Output() checkCardEvent = new EventEmitter<boolean>();
    loadingImage = true;
    imageBytes = '';
    cardChecked = false;
    typeVideo = FileTypeEnum.VIDEO;
    readonly TAG_IMG = 'img';
    readonly TAG_SPAN = 'span';
    readonly TAG_CIRCLE = 'circle';
    readonly TAG_PATH = 'path';

    constructor(private fileService: FileRestService, private cdr: ChangeDetectorRef, private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.loadImage(this.image.s3PathThumbnail);
    }

    loadImage(imagePath: string): void {
        this.fileService.getSingleResource(imagePath).subscribe(response => {
            let binary = '';
            const bytes = new Uint8Array(response);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            const base64String = btoa(binary);
            this.imageBytes = 'data:image/png;base64,' + base64String;
            this.loadingImage = false;
            this.cdr.detectChanges();
        });
    }

    onImageClick(): void {
        this.imageClickedEvent.emit({path: this.image.s3Path, type: this.image.type});
        this.cardChecked = this.cardChecked === true;
    }

    onCheckImage(): void {
        this.cardChecked = !this.cardChecked;
        this.imageMarkedEvent.emit(this.image.id);
        this.checkCardEvent.emit(this.cardChecked);
    }

    onElementClick(event): void {
        const clickedElement = event.target;
        if (!clickedElement.matches(this.TAG_IMG) && !clickedElement.matches(this.TAG_SPAN) && !clickedElement.matches(this.TAG_CIRCLE) && !clickedElement.matches(this.TAG_PATH)) {
            this.onCheckImage();
        } else if (clickedElement.matches(this.TAG_IMG) || clickedElement.matches(this.TAG_CIRCLE) || clickedElement.matches(this.TAG_PATH)) {
            this.onImageClick();
        }
    }

    getImageName(name: string): string {
        if (name) {
            return name;
        }
        return this.translate.instant('CMS.MEDIA.ITEM_NO_TITLE');

    }
}
